import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCalibrationSets,
  setChosenQuestionId,
  setCurElo,
  setQuestions,
  setChosenCalibrationId,
  setQuestionFinished
} from '../../reducers/calibrationSlice';
import { getGradeUserInfo, clearStateGrade } from '../../reducers/gradesSlice';
import CalibrationContent from './CalibrationContent';

import { skipCalibration, submitCalibrationAnswer } from '../../config/calibration';
import EloCalculator from './EloRating'; // Sửa import từ EloRating thành EloCalculator
import BackGround from './assets/BackGround.png';
import Title from './assets/thanhtim.png';
import ExerciseCloseButton from "../../components/button/special-button/ExerciseCloseButton";
import Long1 from './assets/long1.png';
import chat from './assets/chat.png';
import BoxChat from './assets/chat-tail-calibration.png'

import endCalibrationBg2 from './assets/endCalibrationBg2.png';
import endCalibrationBg1 from './assets/endCalibrationBg1.png';
import long2 from './assets/long2.png';
import PrimaryButtonPageLevel from '../../components/button/primary-button/PrimaryButtonLevelPage';
import { useNavigate } from 'react-router-dom';
import "./Calibration.css";
import QuestionStatusIndicator from "./QuestionStatusIndicator1";

const CalibrationMainWrapper = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userElo = useSelector((state) => state.grades.listUserInfo?.elo);
  const listUserInfo = useSelector((state) => state.grades.listUserInfo);
  const { calibrationSets, seenQuestions, questions, chosenQuestionSetId, curElo, chosenCalibrationId } = useSelector((state) => state.calibration);
  const [showExitConfirm, setShowExitConfirm] = useState(false);

	const playingAudioRef = useRef(null);
	const [currentScreen, setCurrentScreen] = useState(1); // 1: Màn hình khởi động, 2: Màn hình chọn lớp, 3: CalibrationContent

  const [endCalibration, setEndCalibration] = useState(0); // 0: None, 1 :show end 1, 2: show end 2
  const [selectedQuestion, setSelectedQuestion] = useState(0); // Lưu câu hỏi được chọn
  const questionTemplateAvailable = ["MultipleChoice", "GapFill", "VerticalMultipleChoice", "VerticalGapFill", "DragDrop", "DragDropMulti", "MultipleResponse", "VerticalMultipleResponse"];
  const [showLong1, setShowLong1] = useState(false); // Thêm trạng thái để kiểm soát hiển thị Long1Hello
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [countdown, setCountdown] = useState(null); // Trạng thái cho đếm ngược

  useEffect(() => {
    if (listUserInfo?.calibrationStatus && listUserInfo?.calibrationStatus > 0) {
      navigate("/");
    }
    if (!calibrationSets) {
      dispatch(getCalibrationSets());
    }
    if (!userElo) {
      dispatch(getGradeUserInfo());
    } else if (!curElo) {
      dispatch(setCurElo(userElo))
    }
    if (questions.length === 0 && curElo) {
      pickNewQuestionSet();
    } else {
      for (let i = 0; i < questions.length; i++) {
        if (!questions[i].isFinished) {
          setSelectedQuestion(i)
          break
        }
        if (i === questions.length - 1 && chosenCalibrationId.length === 3 && questions[i].isFinished) {
          setEndCalibration(1)
          setCurrentScreen(2)
          submitAnswers()
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, userElo, calibrationSets, curElo]);

  useEffect(() => {
    if (questions[selectedQuestion]?.template.question && !questionTemplateAvailable.includes(questions[selectedQuestion]?.template.question)) {
      if (selectedQuestion >= questions.length - 1 && chosenCalibrationId.length < 3) {
        pickNewQuestionSet();
      } else {
        setSelectedQuestion((prevIndex) => prevIndex + 1);
      }
      dispatch(setQuestionFinished(selectedQuestion))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chosenCalibrationId, selectedQuestion]);

  useEffect(() => {
    if (chosenCalibrationId.length === 3 && questions[questions.length - 1].isFinished) {
      setEndCalibration(1)
      setCurrentScreen(2)
      submitAnswers()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions]);


  // Hiển thị Long1 và đếm ngược trong 5 giây khi chuyển bộ câu hỏi
  useEffect(() => {
    if (showLong1) {
      // Bắt đầu đếm ngược từ 5
      setCountdown(5);
      const countdownInterval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            setShowLong1(false); // Ẩn Long1 và đếm ngược khi hoàn tất
            return null;
          }
          return prev - 1;
        });
      }, 1000); // Giảm mỗi giây

      // Dọn dẹp interval khi component unmount hoặc showLong1 thay đổi
      return () => clearInterval(countdownInterval);
    }
  }, [showLong1]);

  // console.log("questions", questions);
  // console.log("chosenCalibrationId", chosenCalibrationId);
  // console.log("curElo", curElo);
  // console.log("calibrationSets", calibrationSets);

  const pickNewQuestionSet = () => {
    if (calibrationSets && chosenCalibrationId.length < 3 && curElo) {
      let randomQuestions = null;
      let questionSets = null;
      let calibrationSet = null;
      for (calibrationSet of calibrationSets) {
        if ((calibrationSet.eloRange[0] <= curElo && curElo <= calibrationSet.eloRange[1])) {
          questionSets = calibrationSet.questionSets;
          let randomNumber = Math.floor(Math.random() * questionSets.length);
          randomQuestions = questionSets[randomNumber];
          break;
        }
      }
      if (!questionSets) {
        questionSets = calibrationSets[calibrationSets.length - 2].questionSets;
        calibrationSet = calibrationSets[calibrationSets.length - 2];
      }
      if (!randomQuestions) randomQuestions = questionSets[0];
      let randomNumber = 0
      while ((chosenQuestionSetId.includes(randomQuestions[0].questionId)) && randomNumber < questionSets.length) {
        randomQuestions = questionSets[randomNumber++]
      }

      if(chosenCalibrationId.length !== 0) setShowLong1(true);
      const clonedQuestions = JSON.parse(JSON.stringify(randomQuestions));
      dispatch(setQuestions(clonedQuestions));
      dispatch(setChosenQuestionId(clonedQuestions[0].questionId))
      dispatch(setChosenCalibrationId({ calibrationId: calibrationSet._id, numberOfQuestions: randomQuestions.length }))
    }
  };

  // Hàm chuyển câu hỏi mới
  const handleNextQuestion = () => {
    if (playingAudioRef.current) {
      playingAudioRef.current.pause();
      playingAudioRef.current.currentTime = 0;
    }

    const newElo = EloCalculator({
      isCorrect: questions[selectedQuestion].isCorrect,
      userElo: curElo,
      questionElo: questions[selectedQuestion]?.elo
    })
    dispatch(setCurElo(newElo))
    if (selectedQuestion < questions.length - 1) {
      setSelectedQuestion((prevIndex) => prevIndex + 1);
    } else if (chosenCalibrationId.length < 3) {
      pickNewQuestionSet();
      setSelectedQuestion(prevIndex => prevIndex + 1);
    }
  };

  const showEndCalibration = () => {
    setEndCalibration(1);
  };

  const submitAnswers = async () => {
    if (chosenCalibrationId.length !== 3 || !questions[questions.length - 1].isFinished) return
    let start = 0;
    let end = 0;
    const data = {
      elo: curElo,
      calibrations:
        chosenCalibrationId.map((calibrationInfo, calibrationIndex) => {
          start = end;
          end += calibrationInfo.numberOfQuestions;
          return {
            calibrationId: calibrationInfo.calibrationId,
            elo: 200 + 100 * calibrationIndex,
            questions:
              questions.slice(start, end).map((question) => {
                let answer = question.question.state?.indexItems || question.question.state?.answers || question.question.state?.selected;
                if (!Array.isArray(answer)) answer = [answer]
                return {
                  questionId: question.questionId,
                  answer: answer,
                  correct: question.isCorrect
                }
              })
          }
        })
    }
    try {
      const response = await submitCalibrationAnswer(data);
      console.log("response", response);
    } catch (error) {
      console.error("Error submitting answers:", error);
    }
  }

  return (
    <div>
      {endCalibration === 2 && (
        <div>
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100vw",
              height: "70vh", // hoặc chiều cao ảnh nền
              backgroundImage: `url(${endCalibrationBg2})`, // thay bằng ảnh của bạn
              backgroundSize: "cover",
              backgroundRepeat: "repeat-x",
              backgroundPosition: "bottom",
              zIndex: 0,
            }}
          ></div>
          <div
            style={{
              backgroundColor: "#F1EEF",
              width: "100vw",
              height: "100vh",
            }}
          ></div>
          <div
            style={{
              display: "flex",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              height: "100vh",
              width: "70%",
              padding: "5px",
            }}
          >
            <div
              style={{
                maxWidth: "30%",
                marginBottom: "60px",
                position: "absolute",
                bottom: "50%",
                left: "10%",
                transform: "translate(0, 50%)",
              }}
            >
              <span
                className="mr-2 has-text-kurio-purple-dark has-text-weight-bold"
                style={{
                  textAlign: "left",
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#0A2A66",
                }}
              >
                Tải app KURIO để nhận lộ trình học cá nhân hóa dành riêng cho
                bé!
              </span>
              <PrimaryButtonPageLevel
                style={{
                  backgroundColor: "#6C4AB6",
                  color: "#FFFFFF",
                  fontWeight: "bold",
                  fontSize: "16px",
                  borderRadius: "12px",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                  marginTop: "20px",
                }}
              >
                TẢI APP NGAY
              </PrimaryButtonPageLevel>
            </div>

            <img
              src={long2}
              alt="Long"
              style={{
                position: "absolute",
                right: "0",
                objectFit: "contain",
                bottom: "0",
                width: "40vw",
                height: "auto",
              }}
            />
          </div>
        </div>
      )}

      {endCalibration === 1 && (
        <div style={{ backgroundColor: "#F1EEFC" }}>
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100vw",
              height: "70vh",
              backgroundImage: `url(${endCalibrationBg1})`,
              backgroundSize: "cover",
              backgroundRepeat: "repeat-x",
              backgroundPosition: "bottom",
              backgroundColor: "#F1EEFC",
              zIndex: 0,
            }}
          ></div>
          <div
            style={{
              backgroundColor: "#F1EEF",
              width: "100vw",
              height: "100vh",
            }}
          ></div>
          <div
            style={{
              position: "absolute",
              top: "5%",
              left: "50%",
              transform: "translate(-50%, 0%)",
              width: "30vw",
              height: "auto",
              textAlign: "center",
              padding: "5px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <h1
                style={{
                  color: "#0A2A66",
                  fontSize: "32px",
                  fontWeight: "bold",
                  marginBottom: "8px",
                  textAlign: "left",
                }}
              >
                Hoan hô! <br />
                Bé đã hoàn thành bài đánh giá năng lực!
              </h1>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "16px",
                  color: "#FAFBFC",
                  borderRadius: "16px",
                  border: "2px solid #0A2A66",
                  boxShadow: "2px 2px 0px #0A2A66",
                  gap: "16px",
                  padding: "8px",
                  width: "100%",
                  backgroundColor: "#FAFBFC",
                }}
              >
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    marginRight: "8px",
                    color: "#0A2A66",
                  }}
                >
                  Điểm <br />
                  Elorio
                </span>
                <span
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#572CD1",
                    padding: "8px 16px",
                    border: "2px solid #6C4AB6",
                    borderRadius: "8px",
                    width: "70%",
                    backgroundColor: "#E8E3F8",
                  }}
                >
                  {curElo ? Math.round(curElo) : 0}
                </span>
              </div>
              <PrimaryButtonPageLevel
                onClick={() => {
                  dispatch(clearStateGrade());
                  navigate("/");
                }}
              >
                Tới trang chủ
              </PrimaryButtonPageLevel>
              {/* <span style={{ fontSize: '18px', color: '#6C4AB6', fontWeight: 'bold' }}>
								Tương đương Top 5% của Lớp 3.
							</span> */}
            </div>
          </div>
        </div>
      )}
      {(chosenCalibrationId?.length !== 3 ||
        !questions[questions.length - 1]?.isFinished) && (
        <div
          style={{
            position: "absolute",
            top: "0rem",
            left: "1rem",
          }}
        >
          <ExerciseCloseButton onClick={() => setShowExitConfirm(true)} />
        </div>
      )}

      {currentScreen === 1 && (
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100vh",
            backgroundImage: `url(${BackGround})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            overflow: "hidden",
          }}
        ></div>
      )}
      {currentScreen === 2 && showLong1 && (
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100vh",
            backgroundImage: `url(${BackGround})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            overflow: "hidden",
          }}
        ></div>
      )}
      {currentScreen === 1 && (
        <img
          src={Title}
          alt="Title"
          style={{
            position: "absolute",
            top: "5.88vh", // 40px → 40/680*100 = 5.88vh
            left: "0",
            width: "100%",
            height: "11.76vh", // 80px → 80/680*100 = 11.76vh
            paddingLeft: "3.53vh", // 24px → 24/680*100 = 3.53vh
            paddingRight: "3.53vh", // 24px → 24/680*100 = 3.53vh
            objectFit: "cover",
            maxWidth: "100%",
          }}
        />
      )}

      {/* Màn hình 1: Khởi động với Long1Hello */}
      {currentScreen === 1 && (
        <div
          className="is-flex  is-justify-content-center"
          style={{
            height: "100%",
            width: "100%",
            gap: "4rem", // 64px → 64/680*100 = 9.41vh
            position: "absolute",
            bottom: "0",
          }}
        >
          <div
            className="is-flex is-align-items-flex-end is-justify-content-flex-end"
            style={{ gap: "4rem" }}
          >
            <div
              className="is-flex is-flex-direction-column is-align-items-center is-justify-content-center"
              style={{ height: "100%", maxHeight: "37.5rem" }}
            >
              <div style={{ height: "21.4375rem" }}>
                <div
                  className="is-flex is-flex-direction-column is-align-items-center is-justify-content-center has-text-kurio-main-color-black has-text-weight-bold"
                  style={{
                    width: "22rem",
                    padding: "2rem",
                    borderRadius: "2rem",
                    background: "#F2E4B1",
                    gap: "1rem",
                  }}
                >
                  <p
                    className="has-text-centered"
                    style={{
                      fontSize: "2rem",
                    }}
                  >
                    Bé hãy làm thử bài đánh giá trình độ của Kurio nhé!
                  </p>
                  <div
                    className="is-clickable has-background-kurio-main-color-black has-text-kurio-main-color-white has-text-weight-bold is-uppercase is-flex is-align-items-center is-justify-content-center"
                    style={{
                      // width: "9.125rem",
                      // height: "3.5rem",
                      borderRadius: "1rem",
                      fontSize: "1.25rem",
                      lineHeight: "150%",
                    }}
                    onClick={() => {
                      setCurrentScreen(2);
                      setIsInitialLoad(false);
                    }}
                  >
                    <div
                      className="has-background-kurio-main-color-purple has-text-kurio-main-color-white has-text-weight-bold is-uppercase is-flex is-align-items-center is-justify-content-center"
                      style={{
                        width: "9.125rem",
                        height: "3.5rem",
                        borderRadius: "1rem",
                        fontSize: "1.25rem",
                        lineHeight: "150%",
                        border:"1px solid #0a2a66",
                        marginLeft:"0.125rem",
                        marginTop:"-0.15rem",
                        marginBottom:"0.15rem"
                      }}
                    >
                      Bắt đầu
                    </div>
                  </div>
                </div>
                <div className="is-flex is-justify-content-space-between">
                  <img
                    style={{
                      width: "5rem",
                      height: "3rem",
                      marginTop: "-0.125rem",
                    }}
                    src={BoxChat}
                    alt=""
                  />
                  <p
                    className="is-clickable is-uppercase has-text-kurio-main-color-black is-underlined has-text-weight-bold"
                    style={{
                      fontSize: "1rem",
                      marginTop: "1rem",
                      marginRight: "1rem",
                    }}
                    onClick={() => setShowExitConfirm(true)}
                  >
                    &gt; bỏ qua
                  </p>
                </div>
              </div>
            </div>
            <img
              src={Long1}
              alt="Khủng long chào"
              style={{
                // position: "absolute",
                bottom: "0vh", // 0px → 0vh
                left: "50%",
                // transform: "translateX(-50%)",
                width: "38.21806rem",
                height: "30rem",
                maxWidth: "100%",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      )}
      {/* Hiển thị Long2Hello khi chuyển QuestionSet với hiệu ứng 5 giây */}
      {showLong1 && currentScreen === 2 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            gap: "9.41vh",
          }}
        >
          <img
            src={Long1}
            alt="Khủng long chào 2"
            className="hello-image" // Hiệu ứng 5 giây
            style={{
              position: "absolute",
              bottom: "0vh", // 0px → 0vh
              left: "70%",
              transform: "translateX(-50%)",
              width: "47vw",
              height: "auto",
              maxWidth: "100%",
              objectFit: "cover",
              zIndex: "1000",
            }}
          />
          {countdown !== null && (
            <div
              className="countdown-container"
              style={{
                backgroundImage: `url(${chat})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                width: "40vw",
                maxWidth: "36rem",
                minWidth: "20rem",
                aspectRatio: "360 / 295",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                color: "#0A2A66",
                fontWeight: "bold",
                padding: "2vw",
                boxSizing: "border-box",
              }}
            >
              <div className="countdown-text">Xin đợi chút</div>
              <div className="countdown-text">mình đang tính toán</div>
              <div className="countdown">{countdown}</div>
            </div>
          )}
        </div>
      )}

      {showExitConfirm && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 2000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#E8E3F8",
              padding: "24px",
              borderRadius: "16px",
              boxShadow: "3px 3px 0.5px #0A2A66",
              minWidth: "300px",
              textAlign: "center",
            }}
          >
            <h2
              style={{
                marginBottom: "16px",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              Bạn có chắc chắn muốn thoát không?
            </h2>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginTop: "16px",
              }}
            >
              <button
                onClick={async () => {
                  playingAudioRef.current?.pause();
                  await skipCalibration();
                  dispatch(clearStateGrade());
                  navigate("/");
                }}
                style={{
                  backgroundColor: "#6C4AB6",
                  color: "white",
                  padding: "15px 30px",
                  borderRadius: "13px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  fontSize: "16px",
                }}
              >
                Có
              </button>
              <button
                onClick={() => setShowExitConfirm(false)}
                style={{
                  backgroundColor: "#ccc",
                  color: "black",
                  padding: "15px 30px",
                  borderRadius: "13px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  fontSize: "16px",
                }}
              >
                Không
              </button>
            </div>
          </div>
        </div>
      )}

      {currentScreen === 2 &&
        endCalibration === 0 &&
        questions.length !== 0 &&
        !showLong1 && (
          <>
            <QuestionStatusIndicator />
            <CalibrationContent
              question={questions[selectedQuestion]}
              seenQuestions={seenQuestions}
              submitAnswers={submitAnswers}
              playingAudioRef={playingAudioRef}
              handleNextQuestion={handleNextQuestion}
              showEndCalibration={showEndCalibration}
            />
          </>
        )}
    </div>
  );
};

export default CalibrationMainWrapper;
